module.exports = __webpack_public_path__ + "static/media/module_users.cc62a71a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/modules/module_users.png
// module id = ./src/resources/images/modules/module_users.png
// module chunks = 0